import { render, staticRenderFns } from "./mobile-course-segment-form.vue?vue&type=template&id=51ee1423&scoped=true"
import script from "./mobile-course-segment-form.vue?vue&type=script&lang=js"
export * from "./mobile-course-segment-form.vue?vue&type=script&lang=js"
import style0 from "./mobile-course-segment-form.vue?vue&type=style&index=0&id=51ee1423&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ee1423",
  null
  
)

export default component.exports